/**
 * Guards the User B "close previous session and continue" flow from websocket/401
 * forced logout while allow-poll + complete are in flight (same-browser shared sessionStorage).
 */

const LOG = '[SessionTakeover]';

let active = false;
/** @type {string | null} */
let activeChallengeId = null;
/** Ignore stale ws-force-disconnect (4001) briefly after takeover complete. */
let postTakeoverGraceUntil = 0;

const POST_TAKEOVER_GRACE_MS = 6000;

export function isSessionTakeoverInProgress() {
  return active;
}

export function isPostTakeoverGraceActive() {
  return Date.now() < postTakeoverGraceUntil;
}

export function beginPostTakeoverGrace(ms = POST_TAKEOVER_GRACE_MS) {
  postTakeoverGraceUntil = Date.now() + ms;
  console.info(`${LOG} post-takeover grace started`, { ms });
}

export function clearPostTakeoverGrace() {
  if (postTakeoverGraceUntil > 0) {
    postTakeoverGraceUntil = 0;
    console.info(`${LOG} post-takeover grace cleared`);
  }
}

/**
 * @param {{ challengeId?: string }} [meta]
 */
/**
 * Remove JWT from storage so websocket/API cannot reuse a token about to be blacklisted.
 * Keeps tenantId and other keys needed for completeSessionChallenge.
 */
export function clearStaleAuthTokensForTakeover() {
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('authToken');
  console.info(`${LOG} cleared stale auth tokens for takeover`);
}

export function beginSessionTakeover(meta = {}) {
  active = true;
  activeChallengeId = meta.challengeId ?? null;
  console.info(`${LOG} takeover flow started`, {
    challengeId: activeChallengeId,
  });
  if (typeof window !== 'undefined') {
    window.dispatchEvent(
      new CustomEvent('session-takeover-started', {
        detail: { challengeId: activeChallengeId },
      })
    );
  }
}

/**
 * @param {string} reason
 * @param {object} [detail]
 */
export function endSessionTakeover(reason = 'finished', detail = {}) {
  if (!active) {
    return;
  }
  const challengeId = activeChallengeId;
  active = false;
  activeChallengeId = null;
  console.info(`${LOG} takeover cleanup/reset`, { reason, challengeId, ...detail });
  if (typeof window !== 'undefined') {
    window.dispatchEvent(
      new CustomEvent('session-takeover-ended', {
        detail: { reason, challengeId, ...detail },
      })
    );
  }
}
